import {types, flow} from 'mobx-state-tree';
import WithFeedbackModel from '../composables/withFeedbackModel';
import * as api from '../../services/api';

export const StaahListingItemModel = types.model('StaahListingItemModel', {
  rates: types.array(
    types.model({
      rateId: types.string,
      rateName: types.string
    })
  ),
  roomId: types.identifier,
  roomName: types.string
});

export type StaahListingItemModelType = typeof StaahListingItemModel.Type;

export const StaahListingModel = types.compose(
  types.model('StaahListingModel', {
    rooms: types.array(StaahListingItemModel)
  }),
  WithFeedbackModel
);

export type StaahListingModelType = typeof StaahListingModel.Type;

export const StaahListingDetailModel = types
  .model('StaahListingDetailModel', {
    isLoading: types.optional(types.boolean, false),
    staahListing: types.maybe(StaahListingModel)
  })
  .actions(self => {
    return {
      getStaahListing: flow(function*(teamId: number) {
        self.isLoading = true;
        try {
          const response = yield api.getStaahMappings(teamId);

          if (response.status === 200 && response.data) {
            self.staahListing = response.data;
          }
        } catch (err) {
          self.isLoading = false;
        } finally {
          self.isLoading = false;
        }
      })
    };
  });

export type StaahListingDetailModelType = typeof StaahListingDetailModel.Type;
export default StaahListingDetailModel;



// WEBPACK FOOTER //
// ./src/models/StaahListingDetailModel/StaahListingDetailModel.ts